import React from "react";
import { Link } from "react-router-dom";

export default function TrackGrid({ title, tracks, variant = "light" }) {
  if (!tracks.length) return null;

  return (
    <section className={`mu-section ${variant === "lavender" ? "mu-section-lavender" : ""}`}>
      <div className="container">
        <h2 className="section-title mb-4">{title}</h2>
        <div className="row g-4">
          {tracks.map((t) => (
            <div className="col-6 col-md-4 col-lg-2" key={t.id}>
              <Link to={`/music/${t.slug}`} className="track-card-link">
                <div className="track-card">
                  <div className="track-art">
                    <img src={t.img} alt={t.title} />
                    <div className="vinyl">
                      <div className="vinyl-disc"></div>
                    </div>
                    <span className="track-genre-badge">{t.genre}</span>
                  </div>
                  <div className="track-info">
                    <div className="track-title">{t.title}</div>
                    <div className="track-meta">{t.artist}</div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
